import {
    Backdrop,
    Grow,
    Modal,
} from '@material-ui/core';
import $ from 'jquery';
import React, { useEffect, useState } from "react";
import { FormattedMessage, useIntl } from 'react-intl'
import Switch from "react-switch";
import ConfigBusiness from '../../commons/config/ConfigBusiness.js';
import Security from '../../commons/security/Security.js';
import * as Utils from '../../commons/utils/Utils';

const DATA_TO_EXPORT = {
  dominio: true,
  unidad: true,
  region: true,
  subRegion: true,
  baseDescripcion: true,
  responsableBaseNombreApellido: true,
  gerenciador: true,
  activo: true,
  inmovilizado: true,
  marcaNombre: true,
  modeloNombre: true,
  modeloTipoNombre: true,
  chasis: true,
  motor: true,
  color: true,
  anio: true,
  fechaAlta: true,
  fechaBaja: true,
  responsable1NombreApellido: true,
  responsable2NombreApellido: true,
  supervisorNombreApellido: true,
  temporalNombreApellido: true,
  centroCostosNombreResponsable: true,
  centroCostosNombre: true,
  centroCostosDireccion:true,
  centroCostosMercado:true,
  centroCostosGerencia:true,
  centroCostosArea:true,
  cebeNombre: true,
  poliza: true,
  lugarGuarda: true,
  certificadoVtv: true,
  telepeaje: true,
  ypfRuta: true,
  kmActual: true,
  dnrpaSeccional: true,
  activoFijo: true,
  nroTitulo: true,
  observaciones: true,
  estado: true,
  combustible: true,
  titular: true,
  proveedorGps: true,
  companiaOrigen: true,
  planPreventivoDescripcion: true,
  guardaEnBase: true,
  guardaLatitud: true,
  guardaLongitud: true,
  guardaDireccion: true,
  guardaAltura: true,
  guardaLocalidad: true,
  guardaProvincia: true,
  guardaPais: true,
  equipamiento: true,
  equipamientoDescripcion: true,
  fechaInicioOperacion: true,
  tipologiaPosicionDescripcion: true,
  funcion: true,
  rendimientoPropio: true,
  rendimientoEsperado: true,
  adjuntoCategoria: true,
  costoPreventivos:  false,
  costoCombustibles: false,
  costoCorrectivos: false,
  costoVencimientos: false,
  costoGestoria: false,
  costoInfracciones: false,
  clase: true,
  division: true,
  disponibilidad: true,
  pesoCargaMaxima: true,
  cantidadCompartimentos: true,
  anchoEspacioCarga: true,
  rutas: true,
  coordinadorNombreApellido: true,
  transportadora: true,
  rentadora: true,
  esReserva: true,
  fechaUltimoCambioDeEstado: false,
  fechaUltimaReserva: false,
  ultimoMotivoCambioEstado: false,
  ayudante: false,
  ploteado: false,
  tipoPloteo: false,
  sedeExterna: false,
  vinculacionRol: false,
  vinculacionActivoRelacionado: false,
  ultimoBipeo: false,
  // VEC-4068: las columnas nuevas vienen destildadas por defecto
  tanquePropio: false,
  capacidadTanque: false
}

const handleInitSelectionsExport = () => {
  let dataInit = JSON.parse(JSON.stringify(DATA_TO_EXPORT))
  let storage = JSON.parse(window.localStorage.getItem('MovilesGridSeleccionExport'))
  if(storage && storage.activo && storage.dataToExport){
    dataInit = storage.dataToExport
  }
  return dataInit
}

const getStorage = () =>{
  let storage = JSON.parse(window.localStorage.getItem('MovilesGridSeleccionExport'))
  if(storage && storage.activo){
   return true
  }
  else{
    return false
  }
}

const MovilesGridExport = (props) => {
  const [loading, setLoading] = useState(false)
  const intl = useIntl()

  const [dataToExport, setDataToExport] = useState(handleInitSelectionsExport)
  const [persisteSeleccionExport, setPersisteSeleccionExport] = useState(getStorage)


  //Switch enabled config
  const [switchEnabled, setSwitchEnabled] = useState({
    unidadEnabled:false,
    regionEnabled:false,
    subRegionEnabled:false,
    colorEnabled:false,
    inmovilizadoEnabled:false,
    centroCostosResponsableEnabled:false,
    titularEnabled:false,
    funcionEnabled:false,
    centroCostosDireccionEnabled:false,
    centroCostosMercadoEnabled:false,
    centroCostosGerenciaEnabled:false,
    centroCostosAreaEnabled:false,
    disponibilidadEnabled: false,
    rutasEnabled:false,
    transportadoraEnabled:false,
    rentingEnabled:false,
    ultimoBipeoEnabled: false,
  })

  useEffect(() => {
    switchConfigEnabled()
  },[])

  const formattedMessageIds = [
    { id: "movilesGrid.render.export_modal.columns_to_export.label_dominio", defaultMessage: "Dominio:", name: "dominio" },
    { id: "movilesGrid.render.export_modal.columns_to_export.label_unidad", defaultMessage: "Unidad:", name: "unidad" },
    { id: "movilesGrid.render.export_modal.columns_to_export.label_region", defaultMessage: "Regionasdasd:", name: "region" },
    { id: "movilesGrid.render.export_modal.columns_to_export.label_subRegion", defaultMessage: "SubRegion:", name: "subRegion" },
    { id: "movilesGrid.render.export_modal.columns_to_export.label_base", defaultMessage: "Base:", name: "baseDescripcion" },
    { id: "movilesGrid.render.export_modal.columns_to_export.label_responsable_base", defaultMessage: "Responsable Base:", name: "responsableBaseNombreApellido" },
    { id: "movilesGrid.render.export_modal.columns_to_export.label_gerenciador", defaultMessage: "Gerenciador:", name: "gerenciador" },
    { id: "movilesGrid.render.export_modal.columns_to_export.label_activo", defaultMessage: "Activo:", name: "activo" },
    { id: "movilesGrid.render.export_modal.columns_to_export.label_inmovilizado", defaultMessage: "Inmovilizado:", name: "inmovilizado" },
    { id: "movilesGrid.render.export_modal.columns_to_export.label_marca", defaultMessage: "Marca:", name: "marcaNombre" },
    { id: "movilesGrid.render.export_modal.columns_to_export.label_modelo", defaultMessage: "Modelo:", name: "modeloNombre" },
    { id: "movilesGrid.render.export_modal.columns_to_export.label_tipo", defaultMessage: "Tipo:", name: "modeloTipoNombre" },
    { id: "movilesGrid.render.export_modal.columns_to_export.label_chasis", defaultMessage: "Chasis:", name: "chasis" },
    { id: "movilesGrid.render.export_modal.columns_to_export.label_motor", defaultMessage: "Motor:", name: "motor" },
    { id: "movilesGrid.render.export_modal.columns_to_export.label_cebeNombre", defaultMessage: "CebeNombre:", name: "cebeNombre" },
    { id: "Disponibilidad", defaultMessage: "Disponibilidad:", name: "disponibilidad" },
    { id: "movilesAbm.render.choferes.label_coordinador", defaultMessage: "Coordinador:", name: "coordinadorNombreApellido" },
    { id: "movilesGrid.render.export_modal.columns_to_export.label_color", defaultMessage: "Color:", name: "color" },
    { id: "movilesGrid.render.export_modal.columns_to_export.label_anio", defaultMessage: "Año:", name: "anio" },
    { id: "movilesGrid.render.export_modal.columns_to_export.label_fec_alta", defaultMessage: "Fec. Alta:", name: "fechaAlta" },
    { id: "movilesGrid.render.export_modal.columns_to_export.label_fec_baja", defaultMessage: "Fec. Baja:", name: "fechaBaja" },
    { id: "movilesGrid.render.export_modal.columns_to_export.label_responsable1", defaultMessage: "Responsable1:", name: "responsable1NombreApellido" },
    { id: "movilesGrid.render.export_modal.columns_to_export.label_responsable2", defaultMessage: "Responsable2:", name: "responsable2NombreApellido" },
    { id: "movilesGrid.render.export_modal.columns_to_export.label_supervisor", defaultMessage: "Supervisor:", name: "supervisorNombreApellido" },
    { id: "movilesGrid.render.export_modal.columns_to_export.label_temporal", defaultMessage: "Temporal:", name: "temporalNombreApellido" },
    { id: "movilesGrid.render.export_modal.columns_to_export.label_centro_costos_de_responsable", defaultMessage: "Centro Costos de Responsable:", name: "centroCostosNombreResponsable" },
    { id: "movilesGrid.render.export_modal.columns_to_export.label_centro_costos", defaultMessage: "Centro Costos:", name: "centroCostosNombre" },
    { id: "movilesGrid.render.filtros_centroCosto_direccion.label", defaultMessage: "CC.Dirección:", name: "centroCostosDireccion" },
    { id: "movilesGrid.render.filtros_centroCosto_mercado.label", defaultMessage: "CC.Mercado:", name: "centroCostosMercado" },
    { id: "movilesGrid.render.filtros_centroCosto_gerencia.label", defaultMessage: "CC.Gerencia:", name: "centroCostosGerencia" },
    { id: "movilesGrid.render.filtros_centroCosto_area.label", defaultMessage: "CC.Área:", name: "centroCostosArea" },
    { id: "movilesGrid.render.export_modal.columns_to_export.label_poliza", defaultMessage: "Poliza:", name: "poliza" },
    { id: "movilesGrid.render.export_modal.columns_to_export.label_lugar_guarda:", defaultMessage: "Lugar Guarda:", name: "lugarGuarda" },
    { id: "movilesGrid.render.export_modal.columns_to_export.label_vtv", defaultMessage: "VTV:", name: "certificadoVtv" },
    { id: "movilesGrid.render.export_modal.columns_to_export.label_telepeaje", defaultMessage: "Telepeaje:", name: "telepeaje" },
    { id: "movilesGrid.render.export_modal.columns_to_export.label_yPFRuta", defaultMessage: "YPFRuta:", name: "ypfRuta" },
    { id: "movilesGrid.render.export_modal.columns_to_export.label_medidor", defaultMessage: "Medidor:", name: "kmActual" },
    { id: "movilesGrid.render.export_modal.columns_to_export.label_DNRPA", defaultMessage: "DNRPA:", name: "dnrpaSeccional" },
    { id: "movilesGrid.render.export_modal.columns_to_export.label_activo_fijo", defaultMessage: "Activo Fijo:", name: "activoFijo" },
    { id: "movilesGrid.render.export_modal.columns_to_export.label_titulo", defaultMessage: "Titulo:", name: "nroTitulo" },
    { id: "movilesGrid.render.export_modal.columns_to_export.label_obs", defaultMessage: "Obs.:", name: "observaciones" },
    { id: "movilesGrid.render.export_modal.columns_to_export.label_estado", defaultMessage: "Estado:", name: "estado" },
    { id: "movilesGrid.render.export_modal.columns_to_export.label_combustible", defaultMessage: "Combustible:", name: "combustible" },
    { id: "movilesGrid.render.export_modal.columns_to_export.label_titular", defaultMessage: "Titular:", name: "titular" },
    { id: "movilesGrid.render.export_modal.columns_to_export.label_prov_gps", defaultMessage: "Prov. Gps:", name: "proveedorGps" },
    { id: "movilesGrid.render.export_modal.columns_to_export.label_cnia_orig", defaultMessage: "Cnia. Orig.:", name: "companiaOrigen" },
    { id: "movilesGrid.render.export_modal.columns_to_export.label_plan_mant", defaultMessage: "Plan Mant.:", name: "planPreventivoDescripcion" },
    { id: "movilesGrid.render.export_modal.columns_to_export.label_guarda_base", defaultMessage: "Guarda Base:", name: "guardaEnBase" },
    { id: "movilesGrid.render.export_modal.columns_to_export.label_guarda_lat", defaultMessage: "Guarda Lat.:", name: "guardaLatitud" },
    { id: "movilesGrid.render.export_modal.columns_to_export.label_guarda_lon", defaultMessage: "Guarda Lon.:", name: "guardaLongitud" },
    { id: "movilesGrid.render.export_modal.columns_to_export.label_guarda_dir", defaultMessage: "Guarda Dir.:", name: "guardaDireccion" },
    { id: "movilesGrid.render.export_modal.columns_to_export.label_guarda_nro", defaultMessage: "Guarda Nro.:", name: "guardaAltura" },
    { id: "movilesGrid.render.export_modal.columns_to_export.label_guarda_loc", defaultMessage: "Guarda Loc.:", name: "guardaLocalidad" },
    { id: "movilesGrid.render.export_modal.columns_to_export.label_guarda_pro", defaultMessage: "Guarda Pro.:", name: "guardaProvincia" },
    { id: "movilesGrid.render.export_modal.columns_to_export.label_guarda_pais", defaultMessage: "Guarda Pais:", name: "guardaPais" },
    { id: "movilesGrid.render.export_modal.columns_to_export.label_equipamiento", defaultMessage: "Equipamiento:", name: "equipamiento" },
    { id: "movilesGrid.render.export_modal.columns_to_export.label_equipamiento_descripcion", defaultMessage: "Equipamiento Descripcion:", name: "equipamientoDescripcion" },
    { id: "movilesGrid.render.export_modal.columns_to_export.label_fecha_inicio_operacion", defaultMessage: "Fecha Inicio Operacion:", name: "fechaInicioOperacion" },
    { id: "movilesGrid.render.export_modal.columns_to_export.label_diagrama_posicion", defaultMessage: "Diagrama de Posicion:", name: "tipologiaPosicionDescripcion" },
    { id: "movilesGrid.render.export_modal.columns_to_export.label_funcion", defaultMessage: "Funcion:", name: "funcion" },
    { id: "movilesGrid.render.export_modal.columns_to_export.label_rendimiento_propio", defaultMessage: "Rendimiento Propio:", name: "rendimientoPropio" },
    { id: "movilesGrid.render.export_modal.columns_to_export.label_rendimiento_esperado", defaultMessage: "Rendimiento Esperado:", name: "rendimientoEsperado" },
    { id: "movilesGrid.render.export_modal.columns_to_export.label_adjunto_categoria", defaultMessage: "Adjunto Categoría:", name: "adjuntoCategoria" },
    { id: "movilesGrid.render.export_modal.columns_to_export.label_tanque_propio", defaultMessage: "Tanque Propio:", name: "tanquePropio" },
    { id: "movilesGrid.render.export_modal.columns_to_export.label_capacidad_tanque", defaultMessage: "Capacidad Tanque:", name: "capacidadTanque" },
    { id: "movilesGrid.render.export_modal.columns_to_export.label_costo_correctivos", defaultMessage: "Costo Correctivos:", name: "costoCorrectivos" },
    { id: "movilesGrid.render.export_modal.columns_to_export.label_costo_preventivos", defaultMessage: "Costo Preventivos:", name: "costoPreventivos" },
    { id: "movilesGrid.render.export_modal.columns_to_export.label_costo_gestoria", defaultMessage: "Costo Gestoría:", name: "costoGestoria" },
    { id: "movilesGrid.render.export_modal.columns_to_export.label_costo_infracciones", defaultMessage: "Costo Infracciones:", name: "costoInfracciones" },
    { id: "movilesGrid.render.export_modal.columns_to_export.label_costo_combustibles", defaultMessage: "Costo Combustibles:", name: "costoCombustibles" },
    { id: "movilesGrid.render.export_modal.columns_to_export.label_costo_vencimientos", defaultMessage: "Costo Vencimientos:", name: "costoVencimientos" },
    { id: "Division", defaultMessage: "División:", name: "division" },
    { id: "movilesAbm.render.general_data.label_clase", defaultMessage: "Clase:", name: "clase" },
    { id: "movilesAbm.render.dimensiones.peso_carga_maxima", defaultMessage: "Peso Carga Máxima (kg):", name: "pesoCargaMaxima" },
    { id: "movilesGrid.render.export_modal.columns_to_export.label_cantidadCompartimentos", defaultMessage: "Número de Cortinas:", name: "cantidadCompartimentos" },
    { id: "movilesAbm.render.dimensiones.ancho_espacio_carga", defaultMessage: "Ancho Espacio de Carga (mts)", name: "anchoEspacioCarga" },
    { id: "Rutas", defaultMessage: "Rutas:", name: "rutas" },
    { id: "movilesAbm.render.general_data.label_Transportadora", defaultMessage: "Transportadora:", name: "transportadora" },
    { id: "movilesGrid.rennder.column_rentadora.label", defaultMessage: "Rentadora:", name: "rentadora" },
    { id: "movilesAbm.render.general_data.label_es_reserva", defaultMessage: "¿Es Reserva?:", name: "esReserva" },
    { id: "MovilesGridExport.render.export_modal.vehiculo_reserva", defaultMessage: "Vehículo Reserva:", name: "vehiculoReserva" },
    { id: "MovilesGridExport.render.export_modal.fecha_ultimo_cambio_de_estado", defaultMessage: "Fec Ult Cambio De Estado:", name: "fechaUltimoCambioDeEstado" },
    { id: "MovilesGridExport.render.export_modal.fecha_ultima_reserva", defaultMessage: "Fec Ult Reserva:", name: "fechaUltimaReserva" },
    { id: "MovilesGridExport.render.export_modal.ultimo_motivo_cambio_de_estado", defaultMessage: "Último Motivo Cambio De Estado:", name: "ultimoMotivoCambioEstado" },
    { id: "moviles.ayudante", defaultMessage: "Ayudante:", name: "ayudante" },
    { id: "moviles.ploteado", defaultMessage: "Ploteado:", name: "ploteado" },
    { id: "moviles.tipoPloteo", defaultMessage: "Tipo de Ploteo:", name: "tipoPloteo" },
    { id: "moviles.sedeExterna", defaultMessage: "Sede Externa:", name: "sedeExterna" },
    ...(ConfigBusiness.get('moviles.vinculacionActivos.habilitado') === 'true' ? [
      { id: "moviles.vinculacionRol", defaultMessage: "Rol de vinculación:", name: "vinculacionRol" },
      { id: "moviles.vinculacionActivoRelacionado", defaultMessage: "Activo vinculado:", name: "vinculacionActivoRelacionado" },
    ] : []),
    { id: "moviles.ultimoBipeo", defaultMessage: "Último Bipeo:", name: "ultimoBipeo" },
  ];

  const switchConfigEnabled = () => {
    Promise.all([
      ConfigBusiness.get('moviles.unidad.grilla'),
      ConfigBusiness.get('moviles.region.grilla'),
      ConfigBusiness.get('moviles.color.habilitado'),
      ConfigBusiness.get('tickets.inmovilizado.habilitado'),
      ConfigBusiness.get('moviles.centroCostosResponsable.habilitado'),
      ConfigBusiness.get('moviles.titular.grilla'),
      ConfigBusiness.get('moviles.funcion.habilitado'),
      ConfigBusiness.get('moviles.cecosDireccion.grilla'),
      ConfigBusiness.get('moviles.cecosMercado.grilla'),
      ConfigBusiness.get('moviles.cecosGerencia.grilla'),
      ConfigBusiness.get('moviles.cecosArea.grilla'),
      ConfigBusiness.get('moviles.subRegion.grilla'),
      ConfigBusiness.get('moviles.clasificador.habilitado'),
      ConfigBusiness.get('moviles.ruta.grilla'),
      ConfigBusiness.get('moviles.transportadora.grilla'),
      ConfigBusiness.get('moviles.rentadora.habilitado'),
      ConfigBusiness.get('moviles.reserva.grilla'),
      ConfigBusiness.get('sedeExterna.habilitado'),
    ]).then((data) => {
      let auxSwitchEnabled = JSON.parse(JSON.stringify(switchEnabled))
        auxSwitchEnabled.unidadEnabled = data[0] === 'true' ? true : false
        auxSwitchEnabled.regionEnabled = data[1] === 'true' ? true : false
        auxSwitchEnabled.colorEnabled = data[2] === 'true' ? true : false
        auxSwitchEnabled.inmovilizadoEnabled = data[3] === 'true' ? true : false
        auxSwitchEnabled.centroCostosResponsableEnabled = data[4] === 'true' ? true : false
        auxSwitchEnabled.titularEnabled = data[5] === 'true' ? true : false
        auxSwitchEnabled.funcionEnabled = data[6] === 'true' ? true : false

        auxSwitchEnabled.centroCostosDireccionEnabled = data[7] === 'true' ? true : false
        auxSwitchEnabled.centroCostosMercadoEnabled = data[8] === 'true' ? true : false
        auxSwitchEnabled.centroCostosGerenciaEnabled = data[9] === 'true' ? true : false
        auxSwitchEnabled.centroCostosAreaEnabled = data[10] === 'true' ? true : false
        auxSwitchEnabled.subRegionEnabled = data[11] === 'true' ? true : false
        auxSwitchEnabled.disponibilidadEnabled = data[12] === 'true' ? true : false
        auxSwitchEnabled.rutasEnabled = data[13] === 'true' ? true : false
        auxSwitchEnabled.transportadoraEnabled = data[14] === 'true' ? true : false
        auxSwitchEnabled.rentingEnabled = data[15] === 'true' ? true : false
        auxSwitchEnabled.esReservaEnabled = data[16] === 'true' ? true : false
        auxSwitchEnabled.vehiculoReservaEnabled = data[16] === 'true' ? true : false
        auxSwitchEnabled.fechaUltimaReservaEnabled = data[16] === 'true' ? true : false
        auxSwitchEnabled.ultimoMotivoCambioEstado = data[16] === 'true' ? true : false
        auxSwitchEnabled.sedeExternaEnabled = data[17] === 'true' ? true : false
        auxSwitchEnabled.ultimoBipeoEnabled = Security.hasAnyPermission(['DISPONIBILIDAD_LISTAR', 'DISPONIBILIDAD_ACTIVA_LISTAR'])
      setSwitchEnabled(auxSwitchEnabled)
      if(persisteSeleccionExport){
        validarCamposSeleccionExport()
      }else{
        let auxDataToExport = JSON.parse(JSON.stringify(dataToExport))
          auxDataToExport.unidad = data[0] === 'true' ? true : false
          auxDataToExport.region = data[1] === 'true' ? true : false
          auxDataToExport.color = data[2] === 'true' ? true : false
          auxDataToExport.inmovilizado = data[3] === 'true' ? true : false
          auxDataToExport.centroCostosNombreResponsable = data[4] === 'true' ? true : false
          auxDataToExport.titular = data[5] === 'true' ? true : false
          auxDataToExport.funcion = data[6] === 'true' ? true : false

          auxDataToExport.centroCostosDireccion = data[7] === 'true' ? true : false
          auxDataToExport.centroCostosMercado = data[8] === 'true' ? true : false
          auxDataToExport.centroCostosGerencia = data[9] === 'true' ? true : false
          auxDataToExport.centroCostosArea = data[10] === 'true' ? true : false
          auxDataToExport.subRegion = data[11] === 'true' ? true : false
          auxDataToExport.disponibilidad = data[12] === 'true' ? true : false
          auxDataToExport.rutas = data[13] === 'true' ? true : false
          auxDataToExport.transportadora = data[14] === 'true' ? true : false
          auxDataToExport.rentadora = data[15] === 'true' ? true : false
          auxDataToExport.esReserva = data[16] === 'true' ? true : false
          auxDataToExport.vehiculoReserva  = data[16] === 'true' ? true : false
          auxDataToExport.fechaUltimaReserva = data[16] === 'true' ? true : false
          auxDataToExport.ultimoMotivoCambioEstado = data[16] === 'true' ? true : false
          auxDataToExport.sedeExterna = data[17] === 'true' ? true : false
          auxDataToExport.ultimoBipeo = Security.hasAnyPermission(['DISPONIBILIDAD_LISTAR', 'DISPONIBILIDAD_ACTIVA_LISTAR'])
        setDataToExport(auxDataToExport)
      }
    });
  }

  const handleDataExport = (nombre)=>{
    const miState = {...dataToExport};
    switch (nombre) {
      case "dominio":
        miState.dominio = !miState.dominio;
        break;
      case "unidad":
        miState.unidad = !miState.unidad;
        break;
      case "region":
        miState.region = !miState.region;
        break;
      case "subRegion":
        miState.subRegion = !miState.subRegion;
        break;
      case "baseDescripcion":
        miState.baseDescripcion = !miState.baseDescripcion;
        break;
      case "responsableBaseNombreApellido":
        miState.responsableBaseNombreApellido = !miState.responsableBaseNombreApellido;
        break;
      case "gerenciador":
        miState.gerenciador = !miState.gerenciador;
        break;
      case "activo":
        miState.activo = !miState.activo;
        break;
      case "inmovilizado":
        miState.inmovilizado = !miState.inmovilizado;
        break;
      case "marcaNombre":
        miState.marcaNombre = !miState.marcaNombre;
        break;
      case "modeloNombre":
        miState.modeloNombre = !miState.modeloNombre;
        break;
      case "modeloTipoNombre":
        miState.modeloTipoNombre = !miState.modeloTipoNombre;
        break;
      case "chasis":
        miState.chasis = !miState.chasis;
        break;
      case "motor":
        miState.motor = !miState.motor;
        break;
      case "color":
        miState.color = !miState.color;
        break;
      case "anio":
        miState.anio = !miState.anio;
        break;
      case "fechaAlta":
        miState.fechaAlta = !miState.fechaAlta;
        break;
      case "fechaBaja":
        miState.fechaBaja = !miState.fechaBaja;
        break;
      case "responsable1NombreApellido":
        miState.responsable1NombreApellido = !miState.responsable1NombreApellido;
        break;
      case "responsable2NombreApellido":
        miState.responsable2NombreApellido = !miState.responsable2NombreApellido;
        break;
      case "supervisorNombreApellido":
        miState.supervisorNombreApellido = !miState.supervisorNombreApellido;
        break;
      case "temporalNombreApellido":
        miState.temporalNombreApellido = !miState.temporalNombreApellido;
        break;
      case "centroCostosNombreResponsable":
        miState.centroCostosNombreResponsable = !miState.centroCostosNombreResponsable;
        break;
      case "centroCostosNombre":
        miState.centroCostosNombre = !miState.centroCostosNombre;
        break;
      case "centroCostosDireccion":
        miState.centroCostosDireccion = !miState.centroCostosDireccion;
        break;
      case "centroCostosMercado":
        miState.centroCostosMercado = !miState.centroCostosMercado;
        break;
      case "centroCostosGerencia":
        miState.centroCostosGerencia = !miState.centroCostosGerencia;
        break;
      case "centroCostosArea":
        miState.centroCostosArea = !miState.centroCostosArea;
        break;
      case "cebeNombre":
        miState.cebeNombre = !miState.cebeNombre;
        break;
      case "poliza":
        miState.poliza = !miState.poliza;
        break;
      case "lugarGuarda":
        miState.lugarGuarda = !miState.lugarGuarda;
        break;
      case "certificadoVtv":
        miState.certificadoVtv = !miState.certificadoVtv;
        break;
      case "telepeaje":
        miState.telepeaje = !miState.telepeaje;
        break;
      case "ypfRuta":
        miState.ypfRuta = !miState.ypfRuta;
        break;
      case "kmActual":
        miState.kmActual = !miState.kmActual;
        break;
      case "dnrpaSeccional":
        miState.dnrpaSeccional = !miState.dnrpaSeccional;
        break;
      case "activoFijo":
        miState.activoFijo = !miState.activoFijo;
        break;
      case "nroTitulo":
        miState.nroTitulo = !miState.nroTitulo;
        break;
      case "observaciones":
        miState.observaciones = !miState.observaciones;
        break;
      case "estado":
        miState.estado = !miState.estado;
        break;
      case "combustible":
        miState.combustible = !miState.combustible;
        break;
      case "titular":
        miState.titular = !miState.titular;
        break;
      case "proveedorGps":
        miState.proveedorGps = !miState.proveedorGps;
        break;
      case "companiaOrigen":
        miState.companiaOrigen = !miState.companiaOrigen;
        break;
      case "planPreventivoDescripcion":
        miState.planPreventivoDescripcion = !miState.planPreventivoDescripcion;
        break;
      case "tipologiaPosicionDescripcion":
        miState.tipologiaPosicionDescripcion = !miState.tipologiaPosicionDescripcion;
        break;
      case "guardaEnBase":
        miState.guardaEnBase = !miState.guardaEnBase;
        break;
      case "guardaLatitud":
        miState.guardaLatitud = !miState.guardaLatitud;
        break;
      case "guardaLongitud":
        miState.guardaLongitud = !miState.guardaLongitud;
        break;
      case "guardaDireccion":
        miState.guardaDireccion = !miState.guardaDireccion;
        break;
      case "guardaAltura":
        miState.guardaAltura = !miState.guardaAltura;
        break;
      case "guardaLocalidad":
        miState.guardaLocalidad = !miState.guardaLocalidad;
        break;
      case "guardaProvincia":
        miState.guardaProvincia = !miState.guardaProvincia;
        break;
      case "guardaPais":
        miState.guardaPais = !miState.guardaPais;
        break;
      case "equipamiento":
        miState.equipamiento = !miState.equipamiento;
        break;
      case "equipamientoDescripcion":
        miState.equipamientoDescripcion = !miState.equipamientoDescripcion;
        break;
      case "funcion":
        miState.funcion = !miState.funcion;
        break;
      case "fechaInicioOperacion":
        miState.fechaInicioOperacion = !miState.fechaInicioOperacion;
        break;
      case "rendimientoPropio":
          miState.rendimientoPropio = !miState.rendimientoPropio;
        break;
      case "rendimientoEsperado":
          miState.rendimientoEsperado = !miState.rendimientoEsperado;
        break;
      case "adjuntoCategoria":
          miState.adjuntoCategoria = !miState.adjuntoCategoria;
        break;
      case "tanquePropio":
          miState.tanquePropio = !miState.tanquePropio;
        break;
      case "capacidadTanque":
          miState.capacidadTanque = !miState.capacidadTanque;
        break;
      case "costoPreventivos":
        miState.costoPreventivos = !miState.costoPreventivos;
        break;
      case "costoCombustibles":
        miState.costoCombustibles = !miState.costoCombustibles;
        break;
      case "costoCorrectivos":
        miState.costoCorrectivos = !miState.costoCorrectivos;
        break;
      case "costoVencimientos":
        miState.costoVencimientos = !miState.costoVencimientos;
        break;
      case "costoGestoria":
        miState.costoGestoria = !miState.costoGestoria;
        break;
      case "costoInfracciones":
        miState.costoInfracciones = !miState.costoInfracciones;
        break;
      case "clase":
        miState.clase = !miState.clase;
        break;
      case "division":
        miState.division = !miState.division;
        break;
      case "disponibilidad":
        miState.disponibilidad = !miState.disponibilidad;
        break;
      case "pesoCargaMaxima":
        miState.pesoCargaMaxima = !miState.pesoCargaMaxima;
        break;
      case "cantidadCompartimentos":
        miState.cantidadCompartimentos = !miState.cantidadCompartimentos;
        break;
      case "anchoEspacioCarga":
        miState.anchoEspacioCarga = !miState.anchoEspacioCarga;
        break;
      case "rutas":
        miState.rutas = !miState.rutas;
        break;
      case 'coordinadorNombreApellido':
        miState.coordinadorNombreApellido = !miState.coordinadorNombreApellido;
        break;
      case "transportadora":
        miState.transportadora = !miState.transportadora;
        break;
      case "rentadora":
        miState.rentadora = !miState.rentadora;
        break;
      case "esReserva":
        miState.esReserva = !miState.esReserva;
        break;
      case "vehiculoReserva":
        miState.vehiculoReserva = !miState.vehiculoReserva;
        break;
      case "fechaUltimoCambioDeEstado":
        miState.fechaUltimoCambioDeEstado = !miState.fechaUltimoCambioDeEstado;
        break;
      case "fechaUltimaReserva":
        miState.fechaUltimaReserva = !miState.fechaUltimaReserva;
        break;
      case "ultimoMotivoCambioEstado":
        miState.ultimoMotivoCambioEstado = !miState.ultimoMotivoCambioEstado;
        break;
      case "ayudante":
        miState.ayudante = !miState.ayudante;
        break;
      case "ploteado":
        miState.ploteado = !miState.ploteado;
        break;
      case "tipoPloteo":
        miState.tipoPloteo = !miState.tipoPloteo;
        break;
      case "sedeExterna":
        miState.sedeExterna = !miState.sedeExterna;
        break;
      case "vinculacionRol":
        miState.vinculacionRol = !miState.vinculacionRol;
        break;
      case "vinculacionActivoRelacionado":
        miState.vinculacionActivoRelacionado = !miState.vinculacionActivoRelacionado;
      case "ultimoBipeo":
        miState.ultimoBipeo = !miState.ultimoBipeo;
        break;
    }
    if(persisteSeleccionExport){
      window.localStorage.setItem('MovilesGridSeleccionExport', JSON.stringify({activo: persisteSeleccionExport, dataToExport: miState}));
    }
    setDataToExport(miState);
  }

  const generateDivs = () => {
    const sortedFields = formattedMessageIds.sort((a, b) => {
      const textA = a.id ? intl.formatMessage({ id: a.id, defaultMessage: a.defaultMessage }).toLowerCase() : a.defaultMessage.toLowerCase();
      const textB = b.id ? intl.formatMessage({ id: b.id, defaultMessage: b.defaultMessage }).toLowerCase() : b.defaultMessage.toLowerCase();
      return textA.localeCompare(textB);
    });

    return sortedFields.map(({ id, defaultMessage, name }) => {
      const isSwitchEnabled = switchEnabled[`${name}Enabled`] !== undefined ? switchEnabled[`${name}Enabled`] : true;

      if (!isSwitchEnabled) {
        return null;
      }

      return (
        <div className="col-md-3" style={{ display: 'flex', alignItems: 'center', padding: '4px 0px' }} key={name}>
          <label className="col-md-6 label-control col-form-label" htmlFor={name}>
            <FormattedMessage id={id} defaultMessage={defaultMessage} />
          </label>
          <Switch
            onChange={() => handleDataExport(name)}
            checked={dataToExport[name] ? true : false}
            value={dataToExport[name]}
            id={name}
            name={name}
            offColor="#FF4961"
            onColor="#28D094"
            className="col-md-6 align-middle"
          />
        </div>
      );
    });
  };
  
  const handleExportExcel = (event) => {
    
    let queryFilters = props.queryFilters();
    event.preventDefault()
    setLoading(true)
    let auxDataToExport = JSON.stringify({
      colsAExportar: dataToExport,
     
    })
    Utils.sendDataBlob(`/moviles/exportar-excel${queryFilters}`,'POST',auxDataToExport)
      .then(data => {
        let fileBlob = new File([data],'fleet-moviles.xlsx')
        let fileUrl = URL.createObjectURL(fileBlob);
        $("<a />", {
          href: fileUrl,
          download: "fleet-moviles.xlsx"
        }).appendTo("body").get(0).click();
      }).catch((err) => {
        console.log(err)
      }).finally(() => {
        props.handleClose();
        setLoading(false)
      })
  }

  const validarCamposSeleccionExport = () => {
    let storage = JSON.parse(window.localStorage.getItem('MovilesGridSeleccionExport'));
    if (storage && storage.dataToExport) {
      let actualizado = false;
      let dataToExport = { ...storage.dataToExport };
      Object.keys(DATA_TO_EXPORT).forEach(key => {
        if (!(key in dataToExport)) {
          dataToExport[key] = false;
          actualizado = true;
        }
      });
      if (actualizado) {
        window.localStorage.setItem(
          'MovilesGridSeleccionExport',
          JSON.stringify({ ...storage, dataToExport })
        );
        setDataToExport(dataToExport);
      }
    }
  };

  const onChangePersisteSeleccionExport = (value) => {
    window.localStorage.setItem('MovilesGridSeleccionExport', JSON.stringify({activo: value, dataToExport: dataToExport}));
    setPersisteSeleccionExport(value);
  }

  const handleToggleAll = () => {
    var allSelected = Object.keys(dataToExport).every(function(key) { return dataToExport[key]; });
    var newValue = !allSelected;
    var newState = {};
    Object.keys(dataToExport).forEach(function(key) { newState[key] = newValue; });
    setDataToExport(newState);
    if (persisteSeleccionExport) {
      window.localStorage.setItem('MovilesGridSeleccionExport', JSON.stringify({ activo: true, dataToExport: newState }));
    }
  }

  return(
    <Modal open={props.open}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 1000,
      }}
    >
      <Grow in={props.open}>
        <div className="" tabIndex="-1" id="export_modal" role="dialog" aria-labelledby="myModalLabel3">
          <div className="modal-xl modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header bg-fleet">
                <h4 className="modal-title text-white" id="myModalLabel3"><i className="ft-download align-middle icon-modal-title"></i><FormattedMessage id="movilesGrid.render.export_modal.header_datos_generales" defaultMessage=" Exportar Moviles"/></h4>
                <button type="button" onClick={()=>props.handleClose()} className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
              </div>
              <div className="modal-body modal-grey modal-mh ovf-x-hidden">
                <div className="row">
                  <div className="col-md-12">
                    {/*<div className="alert alert-danger" role="alert" hidden={this.state.errors.length===0}>
                      {this.state.errors.map((e, i) => <li key={i}>{e}</li>)}
                    </div>*/}
                    {/* onSubmit={this.handleSubmit} */}
                    <form className="form form-horizontal">
                      <div className="form-body">
                              <div className="card pull-up">
                                    <div className="card-content">
                                      <div className="card-body">
                                        <h4 className="form-section">
                                          <i className="la la-columns"></i><FormattedMessage id="movilesGrid.render.export_modal.columns_to_export.header_columnas_a_exportar" defaultMessage=" Columnas a exportar"/>
                                        </h4>
                                        <div className="row">
                                          {generateDivs()}
                                      </div>
                                      <hr></hr>
                                        <div className="row" style={{ marginBottom: '8px' }}>
                                          <div className=" col-md-3">
                                            <label className="col-md-6 label-control col-form-label" htmlFor="persisteSeleccionExport">
                                              <FormattedMessage id="movilesGrid.render.export_modal.columns_to_export.label_mantener_seleccion" defaultMessage="Mantener Selección"/>:
                                            </label>
                                            <Switch
                                              onChange={(value) => onChangePersisteSeleccionExport(value)}
                                              checked={persisteSeleccionExport}
                                              offColor="#FF4961"
                                              onColor="#28D094"
                                              className =  "col-md-6 align-middle"
                                            />
                                          </div>
                                        </div>
                                        <div className="row">
                                          <div className="col-md-3">
                                            <label className="col-md-6 label-control col-form-label" htmlFor="marcarDesmarcarTodo">
                                              <FormattedMessage id="movilesGrid.render.export_modal.columns_to_export.label_marcar_desmarcar_todo" defaultMessage="Marcar / Desmarcar todo"/>:
                                            </label>
                                            <Switch
                                              onChange={handleToggleAll}
                                              checked={Object.keys(dataToExport).every(function(key) { return dataToExport[key]; })}
                                              offColor="#FF4961"
                                              onColor="#28D094"
                                              className="col-md-6 align-middle"
                                            />
                                          </div>
                                        </div>
                                    </div>
                                  </div>
                            </div>
                        <div className="col-md-12 alert alert-info small" role="alert">
                          <FormattedMessage id="movilesGrid.render.export_modal.esta_accion_puede_demorar_unos_minutos" defaultMessage="Esta acción puede demorar unos minutos."/>
                        </div>
                       </div> 
                    </form>
                  </div>
                </div>
              </div>
              <div className="modal-footer modal-grey">
                <button type="button" className="btn btn-default btn-fleet" onClick={(e)=>handleExportExcel(e)} ><i className={loading ? 'la la-spinner spinner' : 'fa fa-download'}></i><FormattedMessage id="movilesGrid.render.export_modal.finish_button.exportar_a_excel" defaultMessage=" Exportar a Excel"/></button>
                <button type="button" className="btn btn-danger" onClick={()=>props.handleClose()} ><i className="fa fa-times-circle"></i><FormattedMessage id="movilesGrid.render.export_modal.finish_button.cancelar" defaultMessage=" Cancelar"/></button>
              </div>
            </div>
          </div>
        </div>
      </Grow>
    </Modal>
  )
}

export default MovilesGridExport
